import { render, staticRenderFns } from "./OtherOptions.vue?vue&type=template&id=1590f574&scoped=true&"
import script from "./OtherOptions.vue?vue&type=script&lang=js&"
export * from "./OtherOptions.vue?vue&type=script&lang=js&"
import style0 from "./OtherOptions.vue?vue&type=style&index=0&id=1590f574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1590f574",
  null
  
)

/* custom blocks */
import block0 from "./OtherOptions.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports